import { useState } from 'react';
import { 
  Mail, 
  Phone, 
  MapPin, 
  Clock, 
  Send, 
  Facebook, 
  Instagram, 
  Linkedin,
  MessageCircle
} from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Logique d'envoi du formulaire
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const faqs = [
    {
      question: "Comment puis-je accéder aux équipements ?",
      answer: "Plusieurs options : abonnement mensuel, sessions à l'unité, ou formations incluant l'accès aux machines."
    },
    {
      question: "Faut-il avoir des compétences techniques ?",
      answer: "Absolument pas ! Nous accueillons tous les niveaux et proposons des formations d'initiation."
    },
    {
      question: "Quels sont les horaires d'ouverture ?",
      answer: "Ouvert 7j/7. Horaires publics : 9h-18h. Accès membres 24h/24 avec badge."
    },
    {
      question: "Proposez-vous des tarifs étudiants ?",
      answer: "Oui, nous avons des tarifs préférentiels pour étudiants, demandeurs d'emploi et associations."
    }
  ];

  return (
    <section id="contact" className="py-20 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:100px_100px]"></div>
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 text-gray-900 dark:text-white">Contactez-nous</h2>
            <p className="text-xl text-center text-gray-600 dark:text-gray-300 max-w-3xl mx-auto mb-16">
              Prêt à transformer vos idées en réalité ? Contactez-nous pour découvrir 
              comment Fab43 peut vous accompagner dans vos projets d'innovation.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Formulaire de contact */}
            <div className="bg-white dark:bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-200 dark:border-white/10 shadow-sm">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Envoyez-nous un message</h3>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-900 dark:text-white mb-2">Nom complet</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full bg-white dark:bg-gray-700/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-white/50 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-900 dark:text-white mb-2">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full bg-white dark:bg-gray-700/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-white/50 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      required
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-2">Sujet</label>
                  <select
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full bg-white dark:bg-gray-700/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-white/50 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    required
                  >
                    <option value="">Sélectionnez un sujet</option>
                    <option value="membership">Adhésion / Abonnement</option>
                    <option value="training">Formations / Bootcamps</option>
                    <option value="project">Accompagnement projet</option>
                    <option value="partnership">Partenariat</option>
                    <option value="visit">Visite / Découverte</option>
                    <option value="other">Autre</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-2">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    className="w-full bg-white dark:bg-gray-700/50 border border-gray-300 dark:border-white/10 rounded-lg px-4 py-3 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-white/50 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    placeholder="Décrivez votre projet ou vos besoins..."
                    required
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-primary-600 hover:bg-primary-700 text-white py-4 rounded-lg font-semibold transition-all duration-300 flex items-center justify-center space-x-2 transform hover:scale-105"
                >
                  <Send className="h-5 w-5" />
                  <span>Envoyer le message</span>
                </button>
              </form>
            </div>

            {/* Informations de contact */}
            <div className="space-y-8">
              <div className="bg-white dark:bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-200 dark:border-white/10 shadow-sm">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Informations Pratiques</h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-4">
                    <MapPin className="h-6 w-6 text-primary-600 dark:text-primary-400 mt-1" />
                    <div>
                      <p className="font-medium text-gray-900 dark:text-white">Adresse</p>
                      <a 
                        href="https://share.google/hX2tMH6VRJTADaSyc" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200"
                      >
                        CYBER PARK, Rue 18 Janvier 1952<br />Kasserine 1200, Tunisie
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <Phone className="h-6 w-6 text-primary-600 dark:text-primary-400 mt-1" />
                    <div>
                      <p className="font-medium text-gray-900 dark:text-white">Téléphone</p>
                      <a 
                        href="tel:+21656043040" 
                        className="text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200"
                      >
                        +216 56 043 040
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <Mail className="h-6 w-6 text-primary-600 dark:text-primary-400 mt-1" />
                    <div>
                      <p className="font-medium text-gray-900 dark:text-white">Email</p>
                      <a 
                        href="mailto:contact@fab43.com" 
                        className="text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 break-all"
                      >
                        contact@fab43.com
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <Clock className="h-6 w-6 text-primary-600 dark:text-primary-400 mt-1" />
                    <div>
                      <p className="font-medium text-gray-900 dark:text-white">Horaires</p>
                      <p className="text-gray-700 dark:text-gray-300">
                        Lun-Dim : 9h-18h<br />
                        Accès membres : 24h/24
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white dark:bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-200 dark:border-white/10 shadow-sm">
                <h3 className="text-2xl font-bold mb-6">Suivez-nous</h3>
                <div className="flex space-x-4 mb-6">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-gray-100 dark:bg-white/10 p-3 rounded-lg hover:bg-gray-200 dark:hover:bg-white/20 transition-all duration-300 hover:scale-110">
                    <Facebook className="h-6 w-6 text-gray-700 dark:text-white" />
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-gray-100 dark:bg-white/10 p-3 rounded-lg hover:bg-gray-200 dark:hover:bg-white/20 transition-all duration-300 hover:scale-110">
                    <Instagram className="h-6 w-6 text-gray-700 dark:text-white" />
                  </a>
                  <a href="https://linkedin.com/company/fab43" target="_blank" rel="noopener noreferrer" className="bg-gray-100 dark:bg-white/10 p-3 rounded-lg hover:bg-gray-200 dark:hover:bg-white/20 transition-all duration-300 hover:scale-110">
                    <Linkedin className="h-6 w-6 text-gray-700 dark:text-white" />
                  </a>
                  <a href="https://wa.me/21656043040" target="_blank" rel="noopener noreferrer" className="bg-gray-100 dark:bg-white/10 p-3 rounded-lg hover:bg-gray-200 dark:hover:bg-white/20 transition-all duration-300 hover:scale-110">
                    <MessageCircle className="h-6 w-6 text-gray-700 dark:text-white" />
                  </a>
                </div>
                <p className="text-gray-600 dark:text-white/70 text-sm">
                  Restez informé de nos actualités, événements et success stories !
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="mt-16">
            <h3 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-12">
              Questions Fréquentes
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white dark:bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-200 dark:border-white/10 hover:bg-white dark:hover:bg-gray-700/50 transition-all duration-300 shadow-sm">
                  <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">{faq.question}</h4>
                  <p className="text-gray-600 dark:text-white/70 leading-relaxed">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;